import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsOverviewApi } from '../api/bonus-settlements-overview-api';

const api = new BonusSettlementsOverviewApi(API_BASE_URL);

export const fetchBonusSettlements = createAsyncThunk(
    'bonus-settlements/fetchBonusSettlements',
    async ({ searchParams }: { searchParams?: URLSearchParams }, thunkAPI) => {
        const response = await api.getBonusSettlementsOverview(searchParams);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const resetBonusSettlementsState = createAction('bonus-settlements/resetBonusSettlementsState');
